//@ts-check
import { Flex, View } from '@adobe/react-spectrum';
import React from 'react';

import { BulletListGrid, DetailsSectionView } from '@exchange-frontends/components';

import { DetailHeading } from '../../../../components/DetailHeading';
import { useStore } from '../../store';
import parseHTML from '../../utils/ParseHTML';

const SlnDetails = () => {
  /** @type {import('@action-types/ecApp').SolutionDetails} */
  const solutionDetails = useStore((state) => state.detailScreen?.solutionDetails || {});
  const { internalFields } = solutionDetails;

  const sections = [
    {
      id: 'idealCustomerProfile',
      title: 'Use case and Ideal customer profile',
      value: internalFields?.idealCustomerProfile,
    },
    {
      id: 'allSolutionClients',
      title: 'Client(s) this solution has been deployed to',
      value: internalFields?.allSolutionClients?.map((client) => client.clientName),
    },
    {
      id: 'publicSolutionClients',
      title: 'Client(s) who will provide a public testimonial',
      value: internalFields?.publicSolutionClients?.map((client) => client.clientName),
    },
    {
      id: 'solutionValueStatement',
      title: 'Solution value statements (Qualitative)',
      value: internalFields?.solutionValueStatement,
    },
    {
      id: 'businessOutcomes',
      title: 'Business outcomes/results (Quantitative)',
      value: internalFields?.businessOutcomes,
    },
    {
      id: 'competitiveLandscape',
      title: 'Competitive landscape for this solution',
      value: internalFields?.competitiveLandscape,
    },
    {
      id: 'regulatoryCompliance',
      title: 'Regulatory compliance',
      value: internalFields?.regulatoryCompliance,
    },
  ].filter(({ value }) => value?.length);

  if (!sections.length) {
    return null;
  }

  return (
    <Flex gridArea="solutionDetails" direction="column" gap="size-400">
      {sections.map(({ id, title, value }) => (
        <View key={id}>
          <DetailHeading level={4}>{title}</DetailHeading>
          <DetailsSectionView>
            {Array.isArray(value) ? <BulletListGrid values={value} /> : parseHTML(value)}
          </DetailsSectionView>
        </View>
      ))}
    </Flex>
  );
};

export default SlnDetails;
